var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row no-gutters align-items-center transfer-item"},[_c('el-checkbox',{key:_vm.source.value,attrs:{"value":true,"label":_vm.source.value},on:{"change":_vm.handleItemClick}},[_vm._v(_vm._s(`${_vm.source.member_name}(${_vm.source.login_account}人)`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }